import SlSaleInvoiceMdl from '@/models/Sale/SlSaleInvoice'

export default async idInvoice => {
    try {
        //
        const include = ['sl_detail_sale_invoices.wh_product']
        let invoice = await SlSaleInvoiceMdl.include(include).find(idInvoice)
        //
        return invoice
    } catch (error) {
        return error.data.response
    }
}
